module.exports = __webpack_public_path__ + "media/images/pages/home_featured/home-speadtheword-icon-3347749b4340339a943c7f2f51aa172f.png";